// // 'use client';

// // import { useEffect, useState } from 'react';
// // import { motion } from 'framer-motion';
// // import { getVideo } from '../../../../utils/videoDB';

// // const VideoPlayerMenu = ({
// //   videoRef,
// //   videoKey,
// //   handleVideoPlayPage,
// //   handleVideoEnd,
// //   removeWhiteFlashOnVideo,
// // }) => {
// //   const [videoSrc, setVideoSrc] = useState('');

// //   useEffect(() => {
// //     let objectUrl = null;

// //     const fetchAndLoadVideo = async () => {
// //       try {
// //         const splashdecodedUrl = decodeURIComponent(videoKey);
// //         const splashfileName = splashdecodedUrl.split('/').pop();
// //         const result = await getVideo(splashfileName);
// //         const blob = result?.blob;

// //         if (blob && blob instanceof Blob) {
// //           objectUrl = URL.createObjectURL(blob);
// //           setVideoSrc(objectUrl);
// //           console.log('blobUrl', objectUrl);
// //         } else {
// //           console.error('Invalid blob:', blob);
// //           setVideoSrc(videoKey);
// //         }
// //       } catch (err) {
// //         console.error('Error loading video:', err);
// //       }
// //     };

// //     fetchAndLoadVideo();
// //     console.log('updated');

// //     return () => {
// //       if (videoRef?.current) {
// //         videoRef.current.pause();
// //         videoRef.current.removeAttribute('src');
// //         videoRef.current.load();
// //       }
// //       if (objectUrl) {
// //         URL.revokeObjectURL(objectUrl);
// //       }
// //       setVideoSrc('');
// //     };
// //   }, [videoKey]);

// //   const motionProps = removeWhiteFlashOnVideo
// //     ? {}
// //     : {
// //         initial: { opacity: 0 },
// //         animate: { opacity: 1 },
// //         exit: { opacity: 0 },
// //         transition: { duration: 2 },
// //       };

// //   return (
// //     <motion.video
// //       ref={videoRef}
// //       className="position-absolute top-0 start-0 w-100 video-menu  object-fit-cover"
// //       src={videoSrc}
// //       muted
// //       preload="auto"
// //       autoPlay
// //       onPlay={handleVideoPlayPage}
// //       onEnded={handleVideoEnd}
// //       loop={false}
// //       style={{
// //         zIndex: 1,
// //       }}
// //       {...motionProps}
// //     />
// //   );
// // };

// // export default VideoPlayerMenu;

// import { useEffect, useState, useRef } from 'react';
// import { motion } from 'framer-motion';
// import { getVideo } from '../../../../utils/videoDB';
// import { usePxToVw } from '../../../../hooks/usePxToVw';
// import CCToggle from '../../../CCToggle';

// const VideoPlayerMenu = ({
//   videoRef,
//   videoKey, // This will now be the actual video URL
//   videoDbKey, // Optional: specific key for IndexedDB lookup
//   handleVideoPlayPage,
//   handleVideoEnd,
//   removeWhiteFlashOnVideo,
//   captionFileUrl, // URL of the caption file
//   captionSettings, // Caption styling settings from your API
//   setIsCaptionOn,
//   isCaptionOn,
//   selectedLanguage,
//   locationVideo
// }) => {
//   const [videoSrc, setVideoSrc] = useState('');
//   const [captionVttUrl, setCaptionVttUrl] = useState('');
//   const trackRef = useRef(null);
//   const [animatedWords, setAnimatedWords] = useState('');
//   const { pxToVw } = usePxToVw();

//   // Add a ref to track if caption is enabled
//   const isCaptionOnRef = useRef(isCaptionOn);

//   console.log("captionSettings", captionSettings, 'isCaptionON', isCaptionOn, "captionFIle", captionFileUrl)

//   console.log('captionfileurl#########', captionFileUrl);

//   useEffect(() => {
//     isCaptionOnRef.current = isCaptionOn;
//   }, [isCaptionOn]);

//   function extractPath(url) {
//   return url.split(".com/")[1];
// }

//   useEffect(() => {
//     let objectUrl = null;
//     let captionObjectUrl = null;

//     const fetchAndLoadVideo = async () => {
//       try {
      

//         // If we have a specific IndexedDB key, try that first
//         // if (videoDbKey) {
//         //   console.log('🎬 VideoPlayerMenu: Trying IndexedDB with key:', videoDbKey);
//         //   const result = await getVideo(videoDbKey);


//         //   console.log("resultresultresult",result)
//         //   const blob = result?.blob;

//         //   if (blob && blob instanceof Blob) {
//         //     objectUrl = URL.createObjectURL(blob);
//         //     setVideoSrc(objectUrl);
//         //     console.log('✅ VideoPlayerMenu: Successfully loaded video from IndexedDB:', objectUrl);
//         //     return; // Success, exit early
//         //   } else {
//         //     console.log('🎬 VideoPlayerMenu: No valid blob found in IndexedDB');
//         //   }
//         // }

//         // Fallback: Try to extract filename from videoKey and check IndexedDB
//         if (videoKey && videoKey.includes('/')) {
//           const splashdecodedUrl = decodeURIComponent(videoKey);
//           const checkSplashName = splashdecodedUrl.split('/');
//           const checkSplashVideoName = splashdecodedUrl.split('/').pop();

//           let splashfileName = '';




//           if (checkSplashName.includes(checkSplashVideoName) && locationVideo) {
//             // const index = checkSplashName.findIndex(item => item === target);

//             // if (index !== -1) {
//             //   splashfileName =
//             //     checkSplashName.slice(index + 1).join("/") + `_${selectedLanguage}`;
//             // }

//             const result = extractPath(videoKey);
//             splashfileName = `${result}_${selectedLanguage}`

//           } else {
//             splashfileName = splashdecodedUrl.split("/").pop();
//           }

//           console.log(
//             "🎬 VideoPlayerMenu: Trying IndexedDB with extracted filename:",
//             splashfileName
//           );

//           const result = await getVideo(splashfileName.trim());

//           console.log("videoresult", result)
//           const blob = result?.blob;

//           if (blob && blob instanceof Blob) {
//             objectUrl = URL.createObjectURL(blob);
//             setVideoSrc(objectUrl);
//             console.log(
//               '✅ VideoPlayerMenu: Successfully loaded video from IndexedDB with filename:',
//               objectUrl
//             );
//             return; // Success, exit early
//           }
//         }

//         // Final fallback: Use the videoKey as direct URL
//         console.log('🎬 VideoPlayerMenu: Using direct URL fallback:', videoKey);
//         setVideoSrc(videoKey);
//       } catch (err) {
//         console.error('❌ VideoPlayerMenu: Error loading video:', err);
//         console.log('🎬 VideoPlayerMenu: Using direct URL as final fallback:', videoKey);
//         setVideoSrc(videoKey);
//       }
//     };

//     fetchAndLoadVideo();

//     return () => {
//       if (videoRef?.current) {
//         videoRef.current.pause();
//         videoRef.current.removeAttribute('src');
//         videoRef.current.load();
//       }
//       if (objectUrl) {
//         URL.revokeObjectURL(objectUrl);
//       }
//       if (captionObjectUrl) {
//         URL.revokeObjectURL(captionObjectUrl);
//       }
//       return () => {
//         if (objectUrl) URL.revokeObjectURL(objectUrl);
//         if (captionObjectUrl) URL.revokeObjectURL(captionObjectUrl);
//       };
//     };
//   }, [videoKey]);

//   // Load and parse caption file
//   useEffect(() => {
//     if (!captionFileUrl) {
//       setCaptionVttUrl('');
//       return;
//     }

//     const loadCaptionFile = async () => {
//       try {

//         // Check if it's an SRT file and convert to VTT
//         if (captionFileUrl.endsWith('.srt')) {
//           const response = await fetch(captionFileUrl);

//           if (!response.ok) {
//             throw new Error(`Failed to fetch SRT file: ${response.status} ${response.statusText}`);
//           }

//           const srtContent = await response.text();

//           const vttContent = convertSrtToVtt(srtContent);
//           const vttBlob = new Blob([vttContent], { type: 'text/vtt' });
//           const vttUrl = URL.createObjectURL(vttBlob);
//           setCaptionVttUrl(vttUrl);
//         } else if (captionFileUrl.endsWith('.vtt')) {
//           const response = await fetch(captionFileUrl);

//           if (!response.ok) {
//             throw new Error(`Failed to fetch VTT file: ${response.status} ${response.statusText}`);
//           }

//           const vttContent = await response.text();
     

//           const vttBlob = new Blob([vttContent], { type: 'text/vtt' });
//           const vttUrl = URL.createObjectURL(vttBlob);
//           setCaptionVttUrl(vttUrl);
//         } else {
//           console.warn('🎬 VideoPlayerMenu: Unsupported caption file format:', captionFileUrl);
//         }
//       } catch (error) {
//         setCaptionVttUrl(''); // Clear any existing caption URL on error
//       }
//     };

//     loadCaptionFile();
//   }, [captionFileUrl]);

//   const animateWords = text => {
//     const words = text.split(' ').filter(Boolean);

//     // Reset first
//     setAnimatedWords([]);

//     setTimeout(() => {
//       setAnimatedWords(words);
//     }, 10);
//   };

//   // Setup caption track when video is ready
//   useEffect(() => {
//     if (!videoRef.current || !captionVttUrl || !captionSettings) {
//       return;
//     }

//     console.log('🎬 VideoPlayerMenu: Setting up caption track with URL:', captionVttUrl);

//     // Remove existing track if any
//     const existingTracks = videoRef.current.querySelectorAll('track');
//     existingTracks.forEach(track => {
//       track.remove();
//     });

//     // Create new track element
//     const track = document.createElement('track');
//     track.kind = 'captions';
//     track.label = 'English';
//     track.srclang = 'en';
//     track.src = captionVttUrl;
//     track.default = true;
//     trackRef.current = track;

 

//     // Add track to video
//     videoRef.current.appendChild(track);

//     // Enable captions
//     const textTracks = videoRef.current.textTracks;
//     if (textTracks && textTracks.length > 0) {

//       textTracks[0].mode = 'hidden';

//       // Add event listeners for debugging
//       textTracks[0].addEventListener('load', () => {
//         console.log('✅ VideoPlayerMenu: Caption track loaded successfully');
//       });

//       textTracks[0].addEventListener('error', e => {
//         console.error('❌ VideoPlayerMenu: Caption track error:', e);
//       });

//       textTracks[0].oncuechange = () => {
//         const activeCues = Array.from(textTracks[0].activeCues || []);
     
//         // Dispatch custom events for MappedInMap synchronization
//         const captionEvent = new CustomEvent('captionChange', {
//           detail: {
//             activeCues: activeCues,
//             hasActiveCues: activeCues.length > 0,
//             cueText: activeCues.length > 0 ? activeCues[0].text.trim() : '',
//             startTime: activeCues.length > 0 ? activeCues[0].startTime : 0,
//             endTime: activeCues.length > 0 ? activeCues[0].endTime : 0,
//           },
//         });

//         // Dispatch to video element so MappedInMap can listen
//         if (videoRef.current) {
//           videoRef.current.dispatchEvent(captionEvent);
        
//         }

//         if (activeCues.length > 0) {
//           const cueText = activeCues[0].text.trim();

//           // RESET first (important)
//           setAnimatedWords([]);

//           // Start animation after short delay
//           setTimeout(() => {
//             animateWords(cueText);
//           }, 60); // small delay ensures smooth cue switching
//         } else {
//           setAnimatedWords([]);
//         }
//       };
//     } else {
//       console.warn('🎬 VideoPlayerMenu: No text tracks found on video element');
//     }

//     return () => {
//       if (trackRef.current) {
//         trackRef.current.remove();
//       }
//     };
//   }, [videoRef, captionVttUrl, captionSettings]);

//   // SRT to VTT converter function
//   const convertSrtToVtt = srtContent => {
//     try {
//       if (!srtContent || typeof srtContent !== 'string') {
//         return '';
//       }

//       // Remove BOM if present
//       srtContent = srtContent.replace(/^\uFEFF/, '');

//       // Normalize line endings
//       let vttContent = srtContent
//         .replace(/\r\n/g, '\n')
//         .replace(/\r/g, '\n')
//         .replace(/\n+/g, '\n')
//         .trim();

//       // Add VTT header
//       vttContent = 'WEBVTT\n\n' + vttContent;

//       // Convert timing format: comma to dot for milliseconds
//       vttContent = vttContent.replace(/(\d{2}:\d{2}:\d{2}),(\d{3})/g, '$1.$2');

//       // Remove SRT index numbers
//       vttContent = vttContent.replace(/^\d+\s*$/gm, '');

//       // Clean up empty lines
//       vttContent = vttContent
//         .split('\n')
//         .filter(line => line.trim() !== '')
//         .join('\n');

//       return vttContent;
//     } catch (error) {
//       console.error('Error converting SRT to VTT:', error);
//       return '';
//     }
//   };

//   const getBackgroundColorWithOpacity = () => {
//     const { bgColor, backgroundOpacity } = captionSettings;
//     const opacity = backgroundOpacity / 100;

//     if (bgColor.startsWith('rgba')) {
//       // Extract and update opacity
//       const matches = bgColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)/);
//       if (matches) {
//         const r = matches[1];
//         const g = matches[2];
//         const b = matches[3];
//         return `rgba(${r}, ${g}, ${b}, ${opacity})`;
//       }
//     } else if (bgColor.startsWith('rgb')) {
//       // Convert rgb to rgba
//       const matches = bgColor.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
//       if (matches) {
//         return `rgba(${matches[1]}, ${matches[2]}, ${matches[3]}, ${opacity})`;
//       }
//     } else if (bgColor.startsWith('#')) {
//       // Convert hex to rgba
//       const hex = bgColor.replace('#', '');
//       const r = parseInt(hex.substring(0, 2), 16);
//       const g = parseInt(hex.substring(2, 4), 16);
//       const b = parseInt(hex.substring(4, 6), 16);
//       return `rgba(${r}, ${g}, ${b}, ${opacity})`;
//     }

//     // Default fallback
//     return `rgba(0, 0, 0, ${opacity})`;
//   };

//   const getTextShadowValue = () => {
//     const { textShadowH, textShadowV, textShadowBlur, textShadowColor } = captionSettings;
//     return `${textShadowH}px ${textShadowV}px ${textShadowBlur}px ${textShadowColor}`;
//   };

//   // Get caption styling from settings
//   const getCaptionStyle = () => {
//     if (!captionSettings) return {};

//     return {
//       display: isCaptionOn ? 'block' : 'none',
//       color: `${captionSettings.textColor}` || '#fff',
//       backgroundColor: getBackgroundColorWithOpacity() || 'rgba(0,0,0,0.55)',
//       fontSize: `${pxToVw(captionSettings.fontSize)}` || '24px',
//       padding: `${pxToVw(captionSettings.padding)}` || '6px 14px',
//       fontWeight: `${captionSettings.fontWeight}` || '600',
//       textShadow: getTextShadowValue() || '0px 0px 6px rgba(0,0,0,0.9)',
//       lineHeight: `${pxToVw(captionSettings.lineHeight)}` || '1.35',
//       letterSpacing: `${pxToVw(captionSettings.letterSpacing)}` || '0px',
//       fontFamily: captionSettings.fontFamily || 'Roboto, Arial, sans-serif',

//       // POSITION
//       position: 'absolute',
//       left: '50%',
//       bottom: `${pxToVw(captionSettings.bottom) || '5vw'}`,

//       transform: 'translateX(-50%)',
//       maxWidth: '85%',

//       // YouTube rounded feel
//       borderRadius: `${pxToVw(captionSettings.borderRadius)}` || '6px',

//       // Animation smoothness
//       transition: `opacity ${captionSettings.transition}s ease, transform ${captionSettings.transition}s ease`,
//       zIndex: 9999,
//       whiteSpace: 'normal',
//       textAlign: 'center',
//       width: '100%',
//     };
//   };

//   const motionProps = removeWhiteFlashOnVideo
//     ? {}
//     : {
//       initial: { opacity: 0 },
//       animate: { opacity: 1 },
//       exit: { opacity: 0 },
//       transition: { duration: 2 },
//     };

//   return (
//     <>
//       {captionSettings && captionSettings?.status === true && captionFileUrl && (
//         <CCToggle
//           value={isCaptionOn}
//           onChange={state => setIsCaptionOn(state)}
//           captionSettings={captionSettings}
//         />
//       )}

//       <motion.video
//         // id="avatarVideo"
//         ref={videoRef}
//         className="position-absolute top-0 start-0 w-100 video-menu object-fit-cover"
//         src={videoSrc}
//         muted
//         preload="auto"
//         autoPlay
//         onPlay={handleVideoPlayPage}
//         onEnded={handleVideoEnd}
//         loop={false}
//         style={{
//           zIndex: 1,
//         }}
//         {...motionProps}
//       />

//       {captionSettings &&
//         captionSettings?.status === true &&
//         captionFileUrl &&
//         animatedWords.length > 0 && (
//           <motion.div
//             className="position-fixed caption-overlay"
//             style={getCaptionStyle()}
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ duration: 0.2 }}
//           >
//             {animatedWords.map((word, i) => (
//               <motion.span
//                 key={i}
//                 initial={{ opacity: 0, scale: 0.92 }}
//                 animate={{ opacity: 1, scale: 1 }}
//                 transition={{ duration: 0.22, delay: i * 0.09 }}
//                 style={{ display: 'inline-block', marginRight: '14px' }}
//               >
//                 {word}
//               </motion.span>
//             ))}
//           </motion.div>
//         )}
//     </>
//   );
// };

// export default VideoPlayerMenu;


// 'use client';

// import { useEffect, useState } from 'react';
// import { motion } from 'framer-motion';
// import { getVideo } from '../../../../utils/videoDB';

// const VideoPlayerMenu = ({
//   videoRef,
//   videoKey,
//   handleVideoPlayPage,
//   handleVideoEnd,
//   removeWhiteFlashOnVideo,
// }) => {
//   const [videoSrc, setVideoSrc] = useState('');

//   useEffect(() => {
//     let objectUrl = null;

//     const fetchAndLoadVideo = async () => {
//       try {
//         const splashdecodedUrl = decodeURIComponent(videoKey);
//         const splashfileName = splashdecodedUrl.split('/').pop();
//         const result = await getVideo(splashfileName);
//         const blob = result?.blob;

//         if (blob && blob instanceof Blob) {
//           objectUrl = URL.createObjectURL(blob);
//           setVideoSrc(objectUrl);
//           console.log('blobUrl', objectUrl);
//         } else {
//           console.error('Invalid blob:', blob);
//           setVideoSrc(videoKey);
//         }
//       } catch (err) {
//         console.error('Error loading video:', err);
//       }
//     };

//     fetchAndLoadVideo();
//     console.log('updated');

//     return () => {
//       if (videoRef?.current) {
//         videoRef.current.pause();
//         videoRef.current.removeAttribute('src');
//         videoRef.current.load();
//       }
//       if (objectUrl) {
//         URL.revokeObjectURL(objectUrl);
//       }
//       setVideoSrc('');
//     };
//   }, [videoKey]);

//   const motionProps = removeWhiteFlashOnVideo
//     ? {}
//     : {
//         initial: { opacity: 0 },
//         animate: { opacity: 1 },
//         exit: { opacity: 0 },
//         transition: { duration: 2 },
//       };

//   return (
//     <motion.video
//       ref={videoRef}
//       className="position-absolute top-0 start-0 w-100 video-menu  object-fit-cover"
//       src={videoSrc}
//       muted
//       preload="auto"
//       autoPlay
//       onPlay={handleVideoPlayPage}
//       onEnded={handleVideoEnd}
//       loop={false}
//       style={{
//         zIndex: 1,
//       }}
//       {...motionProps}
//     />
//   );
// };

// export default VideoPlayerMenu;

import { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { getVideo } from '../../../../utils/videoDB';
import { usePxToVw } from '../../../../hooks/usePxToVw';
import CCToggle from '../../../CCToggle';
import { convertToCDNUrl } from '../../../../utils/cdnUtils';

const VideoPlayerMenu = ({
  videoRef,
  videoKey, // This will now be the actual video URL
  videoDbKey, // Optional: specific key for IndexedDB lookup
  handleVideoPlayPage,
  handleVideoEnd,
  removeWhiteFlashOnVideo,
  captionFileUrl, // URL of the caption file
  captionSettings, // Caption styling settings from your API
  setIsCaptionOn,
  isCaptionOn,
  selectedLanguage,
  locationVideo
}) => {
  const [videoSrc, setVideoSrc] = useState('');
  const [captionVttUrl, setCaptionVttUrl] = useState('');
  const trackRef = useRef(null);
  const [animatedWords, setAnimatedWords] = useState('');
  const { pxToVw } = usePxToVw();

  // Add a ref to track if caption is enabled
  const isCaptionOnRef = useRef(isCaptionOn);

  console.log("captionSettings", captionSettings, 'isCaptionON', isCaptionOn, "captionFIle", captionFileUrl)

  console.log('captionfileurl#########', captionFileUrl);

  useEffect(() => {
    isCaptionOnRef.current = isCaptionOn;
  }, [isCaptionOn]);

  function extractPath(url) {
  return url.split(".com/")[1];
}


function cleanVideoUrl(url) {
    if (!url) return url;
    const extensions = ['.mp4', '.webm'];
    for (let ext of extensions) {
        const index = url.lastIndexOf(ext);
        if (index !== -1) {
            return url.substring(0, index + ext.length);
        }
    }
    return url;
}

  useEffect(() => {
    let objectUrl = null;
    let captionObjectUrl = null;
    let isMounted = true;

    const fetchAndLoadVideo = async () => {
      try {
        // Early exit if empty videoKey
        if (!videoKey || videoKey.trim() === '') {
          console.warn('VideoPlayerMenu: Empty or invalid videoKey');
          return;
        }

        // Fallback: Try to extract filename from videoKey and check IndexedDB
        if (videoKey && videoKey.includes('/')) {
          const splashdecodedUrl = decodeURIComponent(videoKey);
          const checkSplashName = splashdecodedUrl.split('/');
          const checkSplashVideoName = splashdecodedUrl.split('/').pop();

          let splashfileName = '';

          if (checkSplashName.includes(checkSplashVideoName) && locationVideo) {
            const result = extractPath(videoKey);
            splashfileName = `${result}`
          } else {
            splashfileName = splashdecodedUrl.split("/").pop();
          }

          console.log(
            "🎬 VideoPlayerMenu: Trying IndexedDB with extracted filename:",
            splashfileName
          );

          const result = await getVideo(splashfileName.trim());

          // Check if still mounted before updating state
          if (!isMounted) {
            console.log('Component unmounted, skipping state update');
            return;
          }

          console.log("videoresult", result)
          const blob = result?.blob;

          if (blob && blob instanceof Blob) {
            objectUrl = URL.createObjectURL(blob);
            setVideoSrc(objectUrl);
            console.log(
              '✅ VideoPlayerMenu: Successfully loaded video from IndexedDB with filename:',
              objectUrl
            );
            return; // Success, exit early
          }
        }

        // Final fallback: Use the videoKey as direct URL
        if (!isMounted) return;
        
        console.log('🎬 VideoPlayerMenu: Using direct URL fallback:', cleanVideoUrl(videoKey));
        
        let cdnUrl = cleanVideoUrl(videoKey)
        setVideoSrc(convertToCDNUrl(cdnUrl));
      } catch (err) {
        console.error('❌ VideoPlayerMenu: Error loading video:', err);
        
        if (!isMounted) return;
        
        console.log('🎬 VideoPlayerMenu: Using direct URL as final fallback:', cleanVideoUrl(videoKey));

        let cdnUrl = cleanVideoUrl(videoKey)
        setVideoSrc(convertToCDNUrl(cdnUrl));
      }
    };

    fetchAndLoadVideo();

    return () => {
      isMounted = false;
      
      // Clean up video element
      if (videoRef?.current) {
        const video = videoRef.current;
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
      
      // Clean up object URLs
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
        objectUrl = null;
      }
      if (captionObjectUrl) {
        URL.revokeObjectURL(captionObjectUrl);
        captionObjectUrl = null;
      }
    };
  }, [videoKey, locationVideo, selectedLanguage]);

  // Load and parse caption file
  useEffect(() => {
    if (!captionFileUrl) {
      setCaptionVttUrl('');
      return;
    }

    let isMounted = true;
    let vttObjectUrl = null;

    const loadCaptionFile = async () => {
      try {
        // Check if it's an SRT file and convert to VTT
        if (captionFileUrl.endsWith('.srt')) {
          const response = await fetch(captionFileUrl);

          if (!response.ok) {
            throw new Error(`Failed to fetch SRT file: ${response.status} ${response.statusText}`);
          }

          const srtContent = await response.text();
          
          if (!isMounted) return;

          const vttContent = convertSrtToVtt(srtContent);
          const vttBlob = new Blob([vttContent], { type: 'text/vtt' });
          vttObjectUrl = URL.createObjectURL(vttBlob);
          setCaptionVttUrl(vttObjectUrl);
        } else if (captionFileUrl.endsWith('.vtt')) {
          const response = await fetch(captionFileUrl);

          if (!response.ok) {
            throw new Error(`Failed to fetch VTT file: ${response.status} ${response.statusText}`);
          }

          const vttContent = await response.text();
          
          if (!isMounted) return;

          const vttBlob = new Blob([vttContent], { type: 'text/vtt' });
          vttObjectUrl = URL.createObjectURL(vttBlob);
          setCaptionVttUrl(vttObjectUrl);
        } else {
          console.warn('🎬 VideoPlayerMenu: Unsupported caption file format:', captionFileUrl);
        }
      } catch (error) {
        if (isMounted) {
          setCaptionVttUrl(''); // Clear any existing caption URL on error
        }
      }
    };

    loadCaptionFile();
    
    return () => {
      isMounted = false;
      if (vttObjectUrl) {
        URL.revokeObjectURL(vttObjectUrl);
        vttObjectUrl = null;
      }
    };
  }, [captionFileUrl]);

  const animateWords = text => {
    const words = text.split(' ').filter(Boolean);

    // Reset first
    setAnimatedWords([]);

    setTimeout(() => {
      setAnimatedWords(words);
    }, 10);
  };

  // Setup caption track when video is ready
  useEffect(() => {
    if (!videoRef.current || !captionVttUrl || !captionSettings) {
      return;
    }

    console.log('🎬 VideoPlayerMenu: Setting up caption track with URL:', captionVttUrl);

    const video = videoRef.current;

    // Remove existing track if any
    const existingTracks = video.querySelectorAll('track');
    existingTracks.forEach(track => {
      track.remove();
    });

    // Create new track element
    const track = document.createElement('track');
    track.kind = 'captions';
    track.label = 'English';
    track.srclang = 'en';
    track.src = captionVttUrl;
    track.default = true;
    trackRef.current = track;

    // Add track to video
    video.appendChild(track);

    // Enable captions
    const textTracks = video.textTracks;
    
    // Store event handlers so we can remove them later
    const handleLoad = () => {
      console.log('✅ VideoPlayerMenu: Caption track loaded successfully');
    };
    
    const handleError = (e) => {
      console.error('❌ VideoPlayerMenu: Caption track error:', e);
    };
    
    const handleCueChange = () => {
      const activeCues = Array.from(textTracks[0].activeCues || []);
   
      // Dispatch custom events for MappedInMap synchronization
      const captionEvent = new CustomEvent('captionChange', {
        detail: {
          activeCues: activeCues,
          hasActiveCues: activeCues.length > 0,
          cueText: activeCues.length > 0 ? activeCues[0].text.trim() : '',
          startTime: activeCues.length > 0 ? activeCues[0].startTime : 0,
          endTime: activeCues.length > 0 ? activeCues[0].endTime : 0,
        },
      });

      // Dispatch to video element so MappedInMap can listen
      if (videoRef.current) {
        videoRef.current.dispatchEvent(captionEvent);
      }

      if (activeCues.length > 0) {
        const cueText = activeCues[0].text.trim();

        // RESET first (important)
        setAnimatedWords([]);

        // Start animation after short delay
        setTimeout(() => {
          animateWords(cueText);
        }, 60); // small delay ensures smooth cue switching
      } else {
        setAnimatedWords([]);
      }
    };
    
    if (textTracks && textTracks.length > 0) {
      textTracks[0].mode = 'hidden';

      // Add event listeners
      textTracks[0].addEventListener('load', handleLoad);
      textTracks[0].addEventListener('error', handleError);
      textTracks[0].oncuechange = handleCueChange;
    } else {
      console.warn('🎬 VideoPlayerMenu: No text tracks found on video element');
    }

    return () => {
      // Clean up event listeners
      if (textTracks && textTracks.length > 0) {
        textTracks[0].removeEventListener('load', handleLoad);
        textTracks[0].removeEventListener('error', handleError);
        textTracks[0].oncuechange = null;
      }
      
      // Remove track element
      if (trackRef.current) {
        trackRef.current.remove();
        trackRef.current = null;
      }
    };
  }, [videoRef, captionVttUrl, captionSettings]);

  // SRT to VTT converter function
  const convertSrtToVtt = srtContent => {
    try {
      if (!srtContent || typeof srtContent !== 'string') {
        return '';
      }

      // Remove BOM if present
      srtContent = srtContent.replace(/^\uFEFF/, '');

      // Normalize line endings
      let vttContent = srtContent
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n')
        .replace(/\n+/g, '\n')
        .trim();

      // Add VTT header
      vttContent = 'WEBVTT\n\n' + vttContent;

      // Convert timing format: comma to dot for milliseconds
      vttContent = vttContent.replace(/(\d{2}:\d{2}:\d{2}),(\d{3})/g, '$1.$2');

      // Remove SRT index numbers
      vttContent = vttContent.replace(/^\d+\s*$/gm, '');

      // Clean up empty lines
      vttContent = vttContent
        .split('\n')
        .filter(line => line.trim() !== '')
        .join('\n');

      return vttContent;
    } catch (error) {
      console.error('Error converting SRT to VTT:', error);
      return '';
    }
  };

  const getBackgroundColorWithOpacity = () => {
    const { bgColor, backgroundOpacity } = captionSettings;
    const opacity = backgroundOpacity / 100;

    if (bgColor.startsWith('rgba')) {
      // Extract and update opacity
      const matches = bgColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)/);
      if (matches) {
        const r = matches[1];
        const g = matches[2];
        const b = matches[3];
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      }
    } else if (bgColor.startsWith('rgb')) {
      // Convert rgb to rgba
      const matches = bgColor.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
      if (matches) {
        return `rgba(${matches[1]}, ${matches[2]}, ${matches[3]}, ${opacity})`;
      }
    } else if (bgColor.startsWith('#')) {
      // Convert hex to rgba
      const hex = bgColor.replace('#', '');
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }

    // Default fallback
    return `rgba(0, 0, 0, ${opacity})`;
  };

  const getTextShadowValue = () => {
    const { textShadowH, textShadowV, textShadowBlur, textShadowColor } = captionSettings;
    return `${textShadowH}px ${textShadowV}px ${textShadowBlur}px ${textShadowColor}`;
  };

  // Get caption styling from settings
  const getCaptionStyle = () => {
    if (!captionSettings) return {};

    return {
      display: isCaptionOn ? 'block' : 'none',
      color: `${captionSettings.textColor}` || '#fff',
      backgroundColor: getBackgroundColorWithOpacity() || 'rgba(0,0,0,0.55)',
      fontSize: `${pxToVw(captionSettings.fontSize)}` || '24px',
      padding: `${pxToVw(captionSettings.padding)}` || '6px 14px',
      fontWeight: `${captionSettings.fontWeight}` || '600',
      textShadow: getTextShadowValue() || '0px 0px 6px rgba(0,0,0,0.9)',
      lineHeight: `${pxToVw(captionSettings.lineHeight)}` || '1.35',
      letterSpacing: `${pxToVw(captionSettings.letterSpacing)}` || '0px',
      fontFamily: captionSettings.fontFamily || 'Roboto, Arial, sans-serif',

      // POSITION
      position: 'absolute',
      left: '50%',
      bottom: `${pxToVw(captionSettings.bottom) || '5vw'}`,

      transform: 'translateX(-50%)',
      maxWidth: '85%',

      // YouTube rounded feel
      borderRadius: `${pxToVw(captionSettings.borderRadius)}` || '6px',

      // Animation smoothness
      transition: `opacity ${captionSettings.transition}s ease, transform ${captionSettings.transition}s ease`,
      zIndex: 9999,
      whiteSpace: 'normal',
      textAlign: 'center',
      width: '100%',
    };
  };

  const motionProps = removeWhiteFlashOnVideo
    ? {}
    : {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      transition: { duration: 2 },
    };

  return (
    <>
      {captionSettings && captionSettings?.status === true && captionFileUrl && (
        <CCToggle
          value={isCaptionOn}
          onChange={state => setIsCaptionOn(state)}
          captionSettings={captionSettings}
        />
      )}

      <motion.video
        // id="avatarVideo"
        ref={videoRef}
        className="position-absolute top-0 start-0 w-100 video-menu object-fit-cover"
        src={videoSrc}
        muted
        preload="auto"
        autoPlay
        onPlay={handleVideoPlayPage}
        onEnded={handleVideoEnd}
        loop={false}
        style={{
          zIndex: 1,
        }}
        {...motionProps}
      />

      {captionSettings &&
        captionSettings?.status === true &&
        captionFileUrl &&
        animatedWords.length > 0 && (
          <motion.div
            className="position-fixed caption-overlay"
            style={getCaptionStyle()}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
          >
            {animatedWords.map((word, i) => (
              <motion.span
                key={i}
                initial={{ opacity: 0, scale: 0.92 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.22, delay: i * 0.09 }}
                style={{ display: 'inline-block', marginRight: '14px' }}
              >
                {word}
              </motion.span>
            ))}
          </motion.div>
        )}
    </>
  );
};

export default VideoPlayerMenu;
